import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    imports: [CommonModule]
})
export class TooltipComponent{

  @Input({ required: true }) label!: string;
  @Input({ required: true }) triangleLeft!: number; // Add this line




}
